import { useMemo, type FC } from "react";

import { useCurrentView } from "@ds/hooks/use-current-view";
import { useVisibility } from "@ds/hooks/use-visibility";

import { EntityTypeName } from "@ds/model/entity-model";

import { MainTableDataTypeEnum } from "@ds/modules/table-data/utils/model";

import { MainView } from "@ds/components/main-view";
import { TableTabMenu } from "@ds/components/table/table-tab-menu";

import { InvitationsTableActionsMenu } from "./components/common/invitations-table-actions-menu";
import { CreateInvitationModal } from "./components/forms/create-invitation-form/create-invitation-modal";
import { InvitationInfo } from "./components/invitation-info";
import { InvitationsTable } from "./components/invitations-table";

export const InvitationsMainPage: FC = () => {
  const [currentView] = useCurrentView();
  const [isCreateModalVisible, setIsCreateModalVisible] = useVisibility();

  const filterOptions = useMemo(
    () => ({
      entityType: EntityTypeName.SETTINGS_INVITATION,
      tableType: MainTableDataTypeEnum.Invitations,
    }),
    [],
  );

  if (!currentView) {
    return null;
  }

  return (
    <>
      <MainView
        title="Invitations"
        filterOptions={filterOptions}
        options={<TableTabMenu tableType={filterOptions.tableType} currentView={currentView} />}
        view={<InvitationsTable />}
        info={<InvitationInfo onCreateInvitation={setIsCreateModalVisible(true)} />}
        actions={<InvitationsTableActionsMenu onCreate={setIsCreateModalVisible(true)} />}
      />

      {isCreateModalVisible && <CreateInvitationModal onClose={setIsCreateModalVisible(false)} />}
    </>
  );
};
